const FeaturedBlogSkeleton = () => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-[1.1fr_0.9fr] animate-pulse">
      {/* Text */}
      <div className="flex flex-col px-6 lg:px-10 py-10 lg:py-12">
        {/* Date */}
        <div className="h-4 w-40 bg-gray-200 rounded mb-8" />

        {/* Title lines */}
        <div className="space-y-3">
          <div className="h-10 bg-gray-200 rounded w-full" />
          <div className="h-10 bg-gray-200 rounded w-11/12" />
          <div className="h-10 bg-gray-200 rounded w-2/3" />
        </div>

        {/* Author byline */}
        <div className="flex items-center gap-3 mt-10">
          <div className="w-9 h-9 rounded-full bg-gray-200" />
          <div className="h-4 w-32 bg-gray-200 rounded" />
        </div>
      </div>

      {/* Image */}
      <div className="order-first lg:order-last px-6 lg:px-10 py-10 lg:py-12 lg:border-l border-gray-200">
        <div className="w-full aspect-[3/2] rounded-md bg-gray-200" />
      </div>
    </div>
  );
};

export default FeaturedBlogSkeleton;
